import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _authorizeActionsRequest = {};
var _authorizeActionsResponse = {};
var _completeFileUploadRequest = {};
var _completeFileUploadResponse = { libraryItems: '_libraryItem' };
var _connectWidgetRequest = {};
var _connectWidgetResponse = {};
var _createFolderRequest = {};
var _createFolderResponse = {};
var _deleteRequest = {};
var _deleteResponse = {};
var _downloadRequest = {};
var _downloadResponse = {};
var _favoriteRequest = {};
var _favoriteResponse = {};
var _folderFields = { lastModified: 'google.protobuf.Timestamp' };
var _folderTree = { subfolders: '_folderTree' };
var _getFolderTreeRequest = {};
var _getFolderTreeResponse = { folderTree: '_folderTree' };
var _getLibraryItemsByIdRequest = {};
var _getLibraryItemsByIdResponse = { libraryItems: '_libraryItem' };
var _libraryItem = {
    createdAt: 'google.protobuf.Timestamp',
    folderFields: '_folderFields',
};
var _moveRequest = {};
var _moveResponse = {};
var _queryFilesRequest = {};
var _queryFoldersRequest = {};
var _queryLibraryFolderItemsRequest = {};
var _queryLibraryFolderItemsResponse = { libraryItems: '_libraryItem' };
var _queryLibraryItemsOffsetResponse = { libraryItems: '_libraryItem' };
var _queryLibraryItemsRequest = {};
var _queryLibraryItemsResponse = { libraryItems: '_libraryItem' };
var _renameRequest = {};
var _renameResponse = {};
var _reportLibraryItemRequest = {};
var _reportLibraryItemResponse = {};
var _shareRequest = {};
var _shareResponse = {};
var _startFileUploadRequest = {};
var _startFileUploadResponse = {};
var _viewFileRequest = {};
var _viewFileResponse = {};
var _viewFolderRequest = {};
var _viewFolderResponse = {};
function resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl(opts) {
    var domainToMappings = {
        'apps._base_domain_': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/file-sharing-server',
                destPath: '',
            },
        ],
        'filesharing._base_domain_': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
            {
                srcPath: '/api/v1',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/file-sharing-server',
                destPath: '/management-api',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/file-sharing-server',
                destPath: '/management-api',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/file-sharing-server',
                destPath: '/management-api',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/file-sharing-server/_api',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        _: [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Generic Mongo like query for files only */
export function queryFiles(payload) {
    var _a = serializer(_queryFilesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryLibraryItemsOffsetResponse, {
        _folderFields: _folderFields,
        _libraryItem: _libraryItem,
    }).fromJSON;
    function __queryFiles(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.QueryFiles',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/files/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryFiles.fromReq = fromReq;
    __queryFiles.__isAmbassador = true;
    return __queryFiles;
}
/** Generic Mongo like query for folders only */
export function queryFolders(payload) {
    var _a = serializer(_queryFoldersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryLibraryItemsOffsetResponse, {
        _folderFields: _folderFields,
        _libraryItem: _libraryItem,
    }).fromJSON;
    function __queryFolders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.QueryFolders',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/folders/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryFolders.fromReq = fromReq;
    __queryFolders.__isAmbassador = true;
    return __queryFolders;
}
/** Fetches all files and folders based on typed query */
export function queryLibraryItems(payload) {
    var _a = serializer(_queryLibraryItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryLibraryItemsResponse, {
        _folderFields: _folderFields,
        _libraryItem: _libraryItem,
    }).fromJSON;
    function __queryLibraryItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.QueryLibraryItems',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/library-items/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryLibraryItems.fromReq = fromReq;
    __queryLibraryItems.__isAmbassador = true;
    return __queryLibraryItems;
}
/** Fetch all files and folders in specific folders. Defaults to root folder as parent when no filter is passed. */
export function queryLibraryFolderItems(payload) {
    var _a = serializer(_queryLibraryFolderItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryLibraryFolderItemsResponse, {
        _folderFields: _folderFields,
        _libraryItem: _libraryItem,
    }).fromJSON;
    function __queryLibraryFolderItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.QueryLibraryFolderItems',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/library-folder-items/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryLibraryFolderItems.fromReq = fromReq;
    __queryLibraryFolderItems.__isAmbassador = true;
    return __queryLibraryFolderItems;
}
/** Gets library items by their ids */
export function getLibraryItemsById(payload) {
    var _a = serializer(_getLibraryItemsByIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getLibraryItemsByIdResponse, {
        _folderFields: _folderFields,
        _libraryItem: _libraryItem,
    }).fromJSON;
    function __getLibraryItemsById(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'GET',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.GetLibraryItemsById',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/library-items',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getLibraryItemsById.fromReq = fromReq;
    __getLibraryItemsById.__isAmbassador = true;
    return __getLibraryItemsById;
}
/** Returns whole tree of folders */
export function getFolderTree(payload) {
    var _a = serializer(_getFolderTreeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFolderTreeResponse, {
        _folderTree: _folderTree,
    }).fromJSON;
    function __getFolderTree(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'GET',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.GetFolderTree',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/folder-trees',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                        protoPath: '/api/v1/file-sharing/folder-trees',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getFolderTree.fromReq = fromReq;
    __getFolderTree.__isAmbassador = true;
    return __getFolderTree;
}
/** Creates new folder. Duplicate folders with same name are allowed */
export function createFolder(payload) {
    var _a = serializer(_createFolderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createFolderResponse, {}).fromJSON;
    function __createFolder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.CreateFolder',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/folders',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createFolder.fromReq = fromReq;
    __createFolder.__isAmbassador = true;
    return __createFolder;
}
export function connectWidget(payload) {
    var _a = serializer(_connectWidgetRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_connectWidgetResponse, {}).fromJSON;
    function __connectWidget(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.ConnectWidget',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/library-items/connect-widget',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __connectWidget.fromReq = fromReq;
    __connectWidget.__isAmbassador = true;
    return __connectWidget;
}
/** Moves file or folder to new parent. Folders are moved with its contents. */
export function move(payload) {
    var _a = serializer(_moveRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_moveResponse, {}).fromJSON;
    function __move(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.Move',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/library-items/move',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __move.fromReq = fromReq;
    __move.__isAmbassador = true;
    return __move;
}
/** Renames file or folder */
export function rename(payload) {
    var _a = serializer(_renameRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_renameResponse, {}).fromJSON;
    function __rename(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.Rename',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/library-items/rename',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rename.fromReq = fromReq;
    __rename.__isAmbassador = true;
    return __rename;
}
/** Deletes file or folder. In case of folder cascades to its children. */
export function _delete(payload) {
    var _a = serializer(_deleteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteResponse, {}).fromJSON;
    function ___delete(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService._Delete',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/library-items/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    ___delete.fromReq = fromReq;
    ___delete.__isAmbassador = true;
    return ___delete;
}
/**
 * Gets url for provided file for preview
 * Increments unique view counter for file
 */
export function viewFile(payload) {
    var _a = serializer(_viewFileRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_viewFileResponse, {}).fromJSON;
    function __viewFile(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.ViewFile',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/library-items/view-file',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __viewFile.fromReq = fromReq;
    __viewFile.__isAmbassador = true;
    return __viewFile;
}
/** Increments unique view counter for folder */
export function viewFolder(payload) {
    var _a = serializer(_viewFolderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_viewFolderResponse, {}).fromJSON;
    function __viewFolder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.ViewFolder',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/library-items/view-folder',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __viewFolder.fromReq = fromReq;
    __viewFolder.__isAmbassador = true;
    return __viewFolder;
}
/** Favorites file or folder */
export function favorite(payload) {
    var _a = serializer(_favoriteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_favoriteResponse, {}).fromJSON;
    function __favorite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.Favorite',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/library-items/favorite',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __favorite.fromReq = fromReq;
    __favorite.__isAmbassador = true;
    return __favorite;
}
/**
 * Returns download url for one or many library items
 *
 * When single file id is given - url to download that file will be returned.
 * When multiple ids are given - url to download a zip archive containing all requested files will be returned.
 * When given one or more folder ids - all subfolders are traversed and included into archive with all files they contain.
 *
 * Zip will start generating upon access of that url.
 * Client can start downloading zip immediately without waiting for 100% completion.
 * Zip is expiring. When url is expired 410 HTTP status will be returned with body { message: "expired" }
 *
 * Does not increment view count
 *
 * Downloads can be performed by everyone or only site members. This is controlled in file sharing settings from the editor.
 */
export function download(payload) {
    var _a = serializer(_downloadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_downloadResponse, {}).fromJSON;
    function __download(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.Download',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/library-items/download',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __download.fromReq = fromReq;
    __download.__isAmbassador = true;
    return __download;
}
/**
 * Initiates new file upload. Provides url to upload to.
 * More on upload flow and example at https://www.npmjs.com/package/wix-file-sharing-client#upload-file
 */
export function startFileUpload(payload) {
    var _a = serializer(_startFileUploadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_startFileUploadResponse, {}).fromJSON;
    function __startFileUpload(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.StartFileUpload',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/files/start-upload',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __startFileUpload.fromReq = fromReq;
    __startFileUpload.__isAmbassador = true;
    return __startFileUpload;
}
/** When upload is completed client should notify server for file to become available */
export function completeFileUpload(payload) {
    var _a = serializer(_completeFileUploadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_completeFileUploadResponse, {
        _folderFields: _folderFields,
        _libraryItem: _libraryItem,
    }).fromJSON;
    function __completeFileUpload(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.CompleteFileUpload',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/files/complete-upload',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __completeFileUpload.fromReq = fromReq;
    __completeFileUpload.__isAmbassador = true;
    return __completeFileUpload;
}
/**
 * Gets shortened url by prefixing supplied url with site domain
 * or by prefixing libraryItemId with site domain and app path to it
 */
export function share(payload) {
    var _a = serializer(_shareRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_shareResponse, {}).fromJSON;
    function __share(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.Share',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/library-items/share',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __share.fromReq = fromReq;
    __share.__isAmbassador = true;
    return __share;
}
/** Responds with actions authorized for items */
export function authorizeActions(payload) {
    var _a = serializer(_authorizeActionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_authorizeActionsResponse, {}).fromJSON;
    function __authorizeActions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.AuthorizeActions',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/authorize-actions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __authorizeActions.fromReq = fromReq;
    __authorizeActions.__isAmbassador = true;
    return __authorizeActions;
}
/** @deprecated */
export function reportLibraryItem(payload) {
    var _a = serializer(_reportLibraryItemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reportLibraryItemResponse, {}).fromJSON;
    function __reportLibraryItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.library_item',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.libraryitems.FileSharingService.ReportLibraryItem',
            url: resolveWixFilesharingApiV1LibraryitemsFileSharingServiceUrl({
                protoPath: '/api/v1/file-sharing/library-items/report',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reportLibraryItem.fromReq = fromReq;
    __reportLibraryItem.__isAmbassador = true;
    return __reportLibraryItem;
}
//# sourceMappingURL=http.impl.js.map